import React from 'react'
import { FeatureFlags } from '@mobi/settings'
import type { Tabs } from '@core/Areas/Account/Pages/Activity/types'
import { get } from '@core/Services/ApiService'
import { useFeature } from '@core/Utils/hooks'

interface RebetTicketsCountResponse {
  rebetTicketsCount: number
}

interface RebetCount {
  isReBetFeatureActive: boolean
  hasRebetBadge: boolean
  isRebetCountMax: boolean
  rebetTicketsCount: number | undefined
  fetchRebetCount: () => void
}

export const useRebetBetCount = (activeTab: Tabs): RebetCount => {
  const isReBetFeatureActive = useFeature(FeatureFlags.REBET_TAB.key)
  const [rebetTicketsCount, setRebetTicketsCount] = React.useState(0)
  const isRebetCountMax = !!rebetTicketsCount && rebetTicketsCount >= 99
  const hasRebetBadge = !!rebetTicketsCount && rebetTicketsCount > 0

  const fetchRebetCount = React.useCallback(() => {
    if (isReBetFeatureActive)
      getRebetTicketsCount()
        .then(res => setRebetTicketsCount(res))
        .catch(() => setRebetTicketsCount(0))
  }, [isReBetFeatureActive])

  React.useEffect(() => {
    fetchRebetCount()
  }, [activeTab, fetchRebetCount])

  return {
    isReBetFeatureActive,
    hasRebetBadge,
    isRebetCountMax,
    rebetTicketsCount,
    fetchRebetCount,
  }
}

const getRebetTicketsCount = async (): Promise<number> => {
  let count = 0

  await get<RebetTicketsCountResponse>({ url: '/$_/accountActivity/tickets/rebet/count' }).then(
    res => {
      if (res && res.rebetTicketsCount) {
        count = res.rebetTicketsCount
      }
    }
  )

  return count
}
